import React, { memo, useMemo, useCallback } from 'react';
import { View } from 'react-native';
import SectionHeader from 'design-system/SectionHeader';
import Amount from 'design-system/Amount';
import { rem } from 'design-system/values';
import { TextButton } from 'design-system/TextButton';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import RowSubscription from './row/RowSubscription';
import SwitchingButton from './row/SwitchingButton';
import { isWeb } from '../../../constants';
import RowSubscriptionTransaction from './transactions/RowSubscriptionTransaction';
const CommittedSpendingRow = ({ item, onOpenCompare, openSubscription, guessedHomeCountry, showExcludedTag = true, }) => {
    const navigation = useMainStackNavigation();
    const styles = useStyles(styleSet);
    const borderStyles = useMemo(() => [
        item.isFirstInSection && styles.firstItem,
        item.isLastInSection && styles.lastItem,
    ], [
        item.isFirstInSection,
        styles.firstItem,
        styles.lastItem,
        item.isLastInSection,
    ]);
    const handleFooterPress = useCallback(() => {
        navigation.navigateDeprecated('PastPendingReasons');
    }, [navigation]);
    if (item.type === 'header') {
        return (<SectionHeader horizontalMargins button={<Amount Numbers-16 showSign {...(item.total > 0 ? { Blue: true } : { Secondary: true })} value={{ value: item.total, currency: item.currency }}/>} style={styles.sectionHeader}>
        {item.title}
      </SectionHeader>);
    }
    if (item.type === 'footer') {
        return (<TextButton text={item.title} small style={styles.footerContainer} onPress={handleFooterPress}/>);
    }
    if (item.type === 'subscription') {
        const { data } = item;
        return (<View style={[styles.item, borderStyles]}>
        <RowSubscription switchingButton={<SwitchingButton data={data} guessedHomeCountry={guessedHomeCountry} onOpenCompare={onOpenCompare}/>} onPress={openSubscription} isCommitted isExcluded={(data.isInternal && showExcludedTag) || undefined} data={data}/>
      </View>);
    }
    const { data } = item;
    return (<View style={[styles.item, borderStyles]}>
      <RowSubscriptionTransaction onPress={(t) => {
            if (t.subscription) {
                openSubscription(t.subscription);
            }
        }} isExcluded={(data.subscription?.isInternal && showExcludedTag) || undefined} switchingButton={<SwitchingButton data={data.subscription} guessedHomeCountry={guessedHomeCountry} onOpenCompare={onOpenCompare}/>} data={data}/>
    </View>);
};
export default memo(CommittedSpendingRow);
const styleSet = createStyleSheets((colors) => ({
    sectionHeader: {
        marginTop: rem(24),
        marginBottom: rem(16),
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    footerContainer: {
        marginHorizontal: rem(16),
        marginTop: rem(16),
        marginBottom: rem(8),
        alignItems: 'center',
        justifyContent: 'center',
    },
    firstItem: {
        ...(isWeb && {
            paddingTop: rem(8),
        }),
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
    },
    lastItem: {
        ...(isWeb && {
            paddingBottom: rem(8),
        }),
        borderBottomLeftRadius: rem(16),
        borderBottomRightRadius: rem(16),
    },
    item: {
        marginHorizontal: rem(16),
        backgroundColor: colors.cards.onDark,
        ...(isWeb && {
            paddingHorizontal: rem(8),
        }),
    },
}));
